
import { RevLink } from '@backmarket/design-system'
import isEmpty from 'lodash/isEmpty'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './SeoSellerContent.constants'
import translations from './SeoSellerContent.translations'

const MAX_DISPLAYED_LENGTH = 420

export default {
  components: {
    RevLink,
  },
  props: {
    description: {
      type: String,
      required: true,
    },
    model: {
      type: String,
      required: true,
    },
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hideLongContent: false,
    }
  },
  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    shouldDisplayReadMore() {
      return (
        this.technicalSpecificationsStringifiedLength +
          this.parsedDescriptionLength >
        MAX_DISPLAYED_LENGTH
      )
    },
    // Since `description` can contain html, we need to
    // count caracters without the tags
    parsedDescriptionLength() {
      const regex = /(<([^>]+)>)/gi
      const parsedDescription = this.description.replace(regex, '')

      return parsedDescription.length
    },

    technicalSpecificationsArray() {
      const { specifications = [] } = this.technicalSpecifications

      return specifications.filter(({ values }) => !isEmpty(values))
    },

    technicalSpecificationsStringifiedLength() {
      return Object.values(this.technicalSpecificationsArray).reduce(
        (strg, { display, values = [] }) => {
          return `${strg} ${display}: ${this.stringifiedSpecificationsValues(
            values.map(({ label }) => label),
          )}`
        },
        '',
      ).length
    },
  },
  created() {
    if (this.shouldDisplayReadMore) {
      this.hideLongContent = true
    }
  },
  methods: {
    toggleEllipsis() {
      this.hideLongContent = !this.hideLongContent
    },

    stringifiedSpecificationsValues(specificationValues) {
      if (!isEmpty(specificationValues)) {
        return Object.values(specificationValues).join(', ')
      }

      return ''
    },
  },
}
